module.exports = __webpack_public_path__ + "static/media/insect(29).468fb711.PNG";